import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../images/dei-noback.png';
import servicesData from './ServicesData.js';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState('');
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined'
      ? window.matchMedia('(max-width: 960px)').matches
      : false
  );

  const toggleMenu = () => setMenuOpen((s) => !s);

  const closeAll = useCallback(() => {
    setMenuOpen(false);
    setOpenDropdown('');
  }, []);

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 960px)');
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  const openMenuAndToggle = (key) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isMobile && !menuOpen) {
      setMenuOpen(true);
      requestAnimationFrame(() => setOpenDropdown(key));
    } else {
      setOpenDropdown((cur) => (cur === key ? '' : key));
    }
  };

  const mobileOpenClass = (key) => (isMobile && openDropdown === key ? ' open' : '');

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeAll(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [closeAll]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeAll}>
          <img src={logo} alt="Dhillon Engineering Inc. logo" className="nav-logo-img" />
        </Link>

        <div
          className="menu-icon"
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          role="button"
        >
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'} />
        </div>

        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className={`nav-item has-dropdown about-dropdown${mobileOpenClass('about')}`}>
            {isMobile ? (
              <button
                type="button"
                className="nav-button"
                onClick={openMenuAndToggle('about')}
                aria-expanded={openDropdown === 'about'}
                aria-haspopup="true"
              >
                <span className="nav-links">About Us</span>
              </button>
            ) : (
              <span className="nav-links">About Us</span>
            )}
            <ul className="dropdown-menu" role="menu">
              <li className="dropdown-item" role="none">
                <Link to="/history" className="dropdown-link" onClick={closeAll} role="menuitem">
                  Our History
                </Link>
              </li>
              <li className="dropdown-item" role="none">
                <Link to="/approach" className="dropdown-link" onClick={closeAll} role="menuitem">
                  Approach
                </Link>
              </li>
            </ul>
          </li>

          <li className={`nav-item has-dropdown${mobileOpenClass('services')}`}>
            {isMobile ? (
              <button
                type="button"
                className="nav-button"
                onClick={openMenuAndToggle('services')}
                aria-expanded={openDropdown === 'services'}
                aria-haspopup="true"
              >
                <span className="nav-links">Services</span>
              </button>
            ) : (
              <span className="nav-links">Services</span>
            )}
            <ul className="dropdown-menu" role="menu">
              {servicesData.map((group, i) => (
                <li key={i} className="dropdown-section" role="none">
                  <span className="dropdown-heading">{group.heading}</span>
                  <ul className="dropdown-list">
                    {group.items.map((item, j) => (
                      <li key={j} className="dropdown-list-item" role="none">
                        <Link
                          to={`/services#${item.slug}`}
                          className="dropdown-link"
                          onClick={closeAll}
                          role="menuitem"
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </li>

          <li className="nav-item">
            <Link to="/our-work" className="nav-links" onClick={closeAll}>
              Our Work
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/careers" className="nav-links" onClick={closeAll}>
              Careers
            </Link>
          </li>

          <li className="nav-item cta">
            <Link to="/contact" className="nav-cta" onClick={closeAll}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
